import {
    BaseLayer,
    BaseLayerFactory_3857,
    BaseLayerType
} from "esdm-map";
import { IBaseLayer } from "esdm-map/dist/baselayers/interfaces/IBaseLayer";
import TileLayer from 'ol/layer/Tile';
import * as olProj from 'ol/proj';
import OSM from 'ol/source/OSM';
import XYZ from 'ol/source/XYZ';
import { ClientBaseLayerFactory } from "./ClientBaseLayerFactory";;

export const LhlpBaseLayers = {
    ...BaseLayerType,
    OrdnanceSurvey_1937to1961 : 999,
    OrdnanceSurvey_1900: 1000,
    Buckinghamshire_OS: 1001,
    SouthYorkshire_OS: 1002,
    Cheshire_OS: 1003,
    Merseyside_OS: 1004
};

export class LhlpBaseLayerFactory extends ClientBaseLayerFactory {
   
    public GetBaseLayerByType(baseLayerType: BaseLayerType, bingApiKey: string = "", esdmApiKey: string = ""): IBaseLayer {

        switch (baseLayerType) {
            case LhlpBaseLayers.OrdnanceSurvey_1937to1961:
                return this.GetOrdnanceSurvey_1937to1961();
                
            case LhlpBaseLayers.OrdnanceSurvey_1900:
                return this.GetOrdnanceSurvey_1900();
                
            case LhlpBaseLayers.OSM_ESDM_contours: //override definition in esdm_map to set maxZoom

                let lyr = new TileLayer({
                    source: new OSM({
                        url: `//{a-f}.osm.esdm.co.uk/900913/c/{z}/{x}/{y}.png?APIKEY=${esdmApiKey}`,
                        maxZoom: 18
                    })
                });
                return new BaseLayer('OSM_ESDM_contours', 'OpenStreetMap', lyr);                

            //case LhlpBaseLayers.BingOS:
            //    let lyr = new TileLayer({
            //        source: new BingMaps({
            //            key: bingApiKey,
            //            imagerySet: "OrdnanceSurvey",
            //            culture: 'en-gb',
            //            maxZoom: 15
            //        })
            //    });
            //    lyr.getSource().setAttributions('© Crown Copyright and database right ' + new Date().getFullYear() + '. All rights reserved.Ordnance Survey Licence number 100023706');
                
            //    return new BaseLayer("OrdnanceSurvey", "Bing Ordnance Survey", lyr);           
        }

        return super.GetBaseLayerByType(baseLayerType, bingApiKey, esdmApiKey);
    }   

    private GetOrdnanceSurvey_1937to1961(): IBaseLayer {
        const lyr = new TileLayer({
            extent: olProj.transformExtent([-7.68, 49.8, 1.77, 60.4], 'EPSG:4326', 'EPSG:3857'),
            preload: Infinity,
            //title: "Great Britain - OS 1:25,000, 1937-61",
            source: new XYZ({
                urls: [
                    'https://api.maptiler.com/tiles/uk-osgb25k1937/{z}/{x}/{y}.jpg?key=IkTLgYxZjV68oqpwdBjp'
                ],
                minZoom: 1,
                maxZoom: 18,
                attributions: 'Mapping from <a href="https://www.nls.uk/">National Library of Scotland</a>',
            }),
            //type: 'overlay',
            visible: false,
            //keytext: 'View the individual sheets of this OS 1:25,000 mapping by selecting "Find by place" above',
            //key: 'geo.nls.uk/mapdata2/os/25000/key/openlayers.html'
        });

        return new BaseLayer("OS25k1937", "OS 1:25,000 1937-1961", lyr);
    }

  

    private GetOrdnanceSurvey_1900(): IBaseLayer {
        const lyr = new TileLayer({
            extent: olProj.transformExtent([-14.169172, 49.205882, 4.393046, 61.483786], 'EPSG:4326', 'EPSG:3857'),
            preload: Infinity,
            //title: "Great Britain - OS One-Inch, 1885-1903 - Hills",
            source: new XYZ({
                attributions: 'Mapping from <a href="https://www.nls.uk/">National Library of Scotland</a><br>We are very grateful to <a href="https://www.davidrumsey.com/">David Rumsey</a> for supporting the scanning and georeferencing of this overlay',
                urls: [
                    'https://api.maptiler.com/tiles/uk-osgb63k1885/{z}/{x}/{y}.png?key=IkTLgYxZjV68oqpwdBjp'
                ],
                minZoom: 1,
                maxZoom: 18
            }),
            //type: 'overlay',
            visible: false
        });
        return new BaseLayer("OSAll1900", "OS All Scales 1900s", lyr);
    }

}